import * as React from "react";
import { TextField } from "@fluentui/react/lib/components/TextField/TextField";
import { PrimaryButton } from "@fluentui/react/lib/components/Button/PrimaryButton/PrimaryButton";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import AppVersionInfo from "../AppVersionInfo/AppVersionInfo";
import AppFeedback from "../AppFeedback/AppFeedback";
import { LocalCacheHelper, StorageType } from "../../helpers/LocalCacheHelper";
import { LocalApiHelper } from "../../helpers/LocalApiHelper";
import { CpbxApiHelper } from "../../helpers/CpbxApiHelper";
import { ConstantsHttpHeader } from "../../constants/ConstantsHttpHeader";
import { Image, IImageProps } from "@fluentui/react/lib/components/Image";
import { Checkbox } from "@fluentui/react/lib/components/Checkbox/Checkbox";
import { Stack, IStackProps } from "@fluentui/react/lib/components/Stack";
import { ICpbxLoginProps } from "./ICpbxLoginProps";
import { ConstantsUrls } from "../../constants/ConstantsUrls";
import WelcomeDialog from "../WelcomeDialog/WelcomeDialog";
import { Loader } from "@fluentui/react-northstar/dist/es/components/Loader/Loader";
import DecommissionDialog from "../DecommissionDialog/DecommissionDialog";
class CpbxLogin extends React.Component<ICpbxLoginProps> {
  private columnProps: Partial<IStackProps> = {
      tokens: { childrenGap: 15 },
      styles: { root: { width: 300 } }
  };

  private cpbxInputsUNMinLength: number = 5;
  private cpbxInputsUNMaxLength: number = 80;
  private cpbxInputsPWDMinLength: number = 8;
  private cpbxInputsPWDMaxLength: number = 30;
  // used for checking correctnes and for doing login
  private cbpxInputsUNSuffix: string = "@deutschland-lan.de";
  private imageProps: Partial<IImageProps> = {
      src: "/assets/logo-corner-big.svg"
  };

  private imagePropsMobile: Partial<IImageProps> = {
      src: "/assets/logo-corner-small.svg"
  };
  /* eslint-disable */
  constructor(props) {
    super(props);
  }
  /* eslint-enable */

  state = {
      un: "",
      pwd: "",
      isDoingLogin: false,
      unErrMsg: "",
      pwdErrMsg: "",
      unValueIsValid: false,
      pwdValueIsValid: false,
      formErrorOccured: false,
      formErrorMsg: "",
      unInputValue: "",
      pwdInputValue: "",
      loginTryNo: 0,
      loginLastTryDateTimeInMs: 0,
      loginForbidden: false,
      saveLoginForever: false,
      tmpEncryptBasicAuthStr: "",
      tmpEncryptIV: ""
  };

  componentDidMount() {
      console.log("start componentDidMount");
      // console.log("this.props.M365UserObjectId='" + this.props.M365UserObjectId + "'");
      this.getEnvironmentData();
  }

  componentWillUnmount() {
      console.log("start componentWillUnmount");
  }

  getEnvironmentData = (): void => {
      console.log("start getEnvironmentData");
      const apiUrlFull = LocalApiHelper.GetLocalUrlForEnv();
      //   console.log("apiUrlFull='" + apiUrlFull + "'");

      fetch(apiUrlFull, {
          method: "GET"
      })
          .then((response) => {
              if (response.ok) {
                  return response.json();
              } else {
                  throw new Error("Response not ok");
              }
          })
          .then((data) => {
              console.log(
                  "set data to localstorage [EnvName='" + data.envName + "']"
              );
              LocalCacheHelper.SetLocalStorageItemCbpxEnvName(data.envName);
              console.log(
                  "set data to localstorage [ProxyUrl='" + data.envProxyUrl + "']"
              );
              LocalCacheHelper.SetLocalStorageItemCbpxProxyUrl(data.envProxyUrl);
          })
          .catch((error) => {
              alert("Error occured...");
              console.log("error", error);
          });

      console.log("end getEnvironmentData");
  };

  handleDoLoginWithDelay = (): void => {
      console.log("start handleDoLoginWithDelay");
      console.log("this.state.loginTryNo=" + this.state.loginTryNo);
      console.log("this.state.loginLastTryDateTimeInMs=" + this.state.loginLastTryDateTimeInMs
      );

      let waitUntilNextLoginTryInMs: number = 0;
      if (this.state.loginTryNo > 1) {
      // try to avoid too big numbers
      // 2 hoch 6 = 64 (Sekunden)
          const tmpLoginTryNo: number =
        this.state.loginTryNo > 6 ? 6 : this.state.loginTryNo;
          waitUntilNextLoginTryInMs =
        this.state.loginLastTryDateTimeInMs +
        Math.pow(2, tmpLoginTryNo) * 1000 -
        Date.now();
          if (waitUntilNextLoginTryInMs < 0) {
              waitUntilNextLoginTryInMs = 0;
          } else {
              this.setState({
                  loginForbidden: true,
                  formErrorMsg:
            this.state.formErrorMsg +
            " Der nächste Login-Versuch ist in ein paar Sekunden wieder möglich."
              });
          }
      }

      // set min wait time to 500ms (otherwise there could be some strange effects...)
      if (waitUntilNextLoginTryInMs <= 500) waitUntilNextLoginTryInMs = 500;

      console.log("waitUntilNextLoginTryInMs=" + waitUntilNextLoginTryInMs);
      setTimeout(this.allowLogin, waitUntilNextLoginTryInMs);
  };

  allowLogin = (): void => {
      console.log("start allowLogin");
      this.setState({
          loginForbidden: false
      });
  };

  // on top (after having logged in succesfully but before showing real content) we have to check which kind
  // of user we have (cpbx 1 or cpbx 2)
  getKindOfCpbxUserBeforeShowingNextView = (): void => {
      console.log("start getKindOfCpbxUserBeforeShowingNextView");
      const reqHeaders: Headers = CpbxApiHelper.GetCpbxRequestHeadersWithAuthPsa(
          this.state.tmpEncryptBasicAuthStr,
          this.props.M365UserObjectId,
          this.state.tmpEncryptIV
      );

      const apiUrlFull: string = CpbxApiHelper.GetCpbxUrlForServicesIntegratedImp(
          this.state.un
      );
      // - apiUrlFull='https://client.deutschland-lan.de/com.broadsoft.xsi-actions/v2.0/user/axels@deutschland-lan.de/services/integratedimp
      //   console.log("apiUrlFull='" + apiUrlFull + "'");

      fetch(apiUrlFull, {
          method: "GET",
          headers: reqHeaders,
          redirect: "follow"
      })
          .then((response) => {
              console.log("response.ok='" + response.ok + "'");
              console.log("response.status='" + response.status + "'");
              console.log("response.statusText='" + response.statusText + "'");
              console.log("response.redirected='" + response.redirected + "'");
              if (response.ok) {
                  return response.json();
              } else {
                  throw new Error("Response not ok");
              }
          })
          .then((data) => {
              console.log(data);
              if (
                  data !== undefined &&
          data.IntegratedIMPService !== undefined &&
          data.IntegratedIMPService.active !== undefined &&
          data.IntegratedIMPService.active.$ !== undefined
              ) {
                  const storageType: StorageType =
            this.state.saveLoginForever === true
                ? StorageType.LocalStorage
                : StorageType.Cookie;
                  const val: string = data.IntegratedIMPService.active.$;
                  console.log("data.IntegratedIMPService.active.$='" + val + "'");
                  /* 19.07.2021 - George said:
                    as discussed, the approach we can take is to verify if the user is CPBX 1.0 (BWKS only) or CPBX 2.0 (BWKS & CISCO) is to check the IMP status.
                    We have agreed that the 2.0 users will have the integrated IMP feature deactivated, as Webex does no longer use the IMP server.
                    */
                  const valType: string =
            val.toLocaleLowerCase() === "true" ? "1" : "2";
                  console.log("valType='" + valType + "' > store that to local-cache");
                  LocalCacheHelper.SetLocalStorageItemCbpxUserTypeDynamic(
                      valType,
                      storageType
                  );
              } else {
                  console.log(
                      "could not retrieve value for data.IntegratedIMPService.active > could not set SetLocalStorageItemCbpxUserTypeDynamic"
                  );
              }

              // now show the next view
              window.location.reload();
          })
          .catch((error) => {
              this.setState({
                  formErrorOccured: true,
                  formErrorMsg:
            "Es ist ein unerwarteter Fehler beim Ermitteln des CPBX-Account-Typs aufgetreten."
              });
              console.log("error", error);
          });
  };

  handleDoLoginWithEncryptedData = (): void => {
      console.log("start handleDoLoginWithEncryptedData");

      const cpbxHeaders = CpbxApiHelper.GetCpbxRequestHeadersWithoutAuth();
      cpbxHeaders.append(
          "Authorization",
          "Basic " + this.state.tmpEncryptBasicAuthStr
      );
      cpbxHeaders.append(
          ConstantsHttpHeader.XTeamsAppUserId,
          this.props.M365UserObjectId
      );
      cpbxHeaders.append(
          ConstantsHttpHeader.XTeamsAppUserIV,
          this.state.tmpEncryptIV
      );

      const apiUrlFull = CpbxApiHelper.GetCpbxUrlForUserProfileWithName(
          this.state.un
      );
      //   console.log("apiUrlFull='" + apiUrlFull + "'");

      fetch(apiUrlFull, {
          method: "GET",
          headers: cpbxHeaders,
          redirect: "follow"
      })
          .then((response) => {
              this.setState({
                  isDoingLogin: false
              });
              console.log("response.ok='" + response.ok + "'");
              console.log("response.status='" + response.status + "'");
              console.log("response.statusText='" + response.statusText + "'");
              console.log("response.redirected='" + response.redirected + "'");
              if (response.ok) {
                  return response.json();
              } else if (response.status === 401) {
                  this.setState({
                      formErrorOccured: true,
                      formErrorMsg:
              "Benutzername und Passwort können nicht zur Autorisierung genutzt werden."
                  });
                  this.handleDoLoginWithDelay();
              } else if (response.status === 403) {
                  this.setState({
                      formErrorOccured: true,
                      formErrorMsg:
              "Fehler bei der Entschlüsselung. Möglicherweise passen User-ID und IV nicht zusammen. Das sollte nicht passieren."
                  });
                  this.handleDoLoginWithDelay();
              } else {
                  throw new Error("Response not ok");
              }
          })
          .then((data) => {
              console.log(data);
              console.log(
                  "this.state.formErrorOccured='" + this.state.formErrorOccured + "'"
              );
              if (data !== undefined && this.state.formErrorOccured === false) {
                  const storageType: StorageType =
            this.state.saveLoginForever === true
                ? StorageType.LocalStorage
                : StorageType.Cookie;
                  LocalCacheHelper.SetLocalStorageItemCbpxUserNameDynamic(
                      this.state.un,
                      storageType
                  );
                  LocalCacheHelper.SetLocalStorageItemCbpxUserBasicAuthStringDynamic(
                      this.state.tmpEncryptBasicAuthStr,
                      storageType
                  );
                  LocalCacheHelper.SetLocalStorageItemCbpxUserProfileMeDynamic(
                      JSON.stringify(data),
                      storageType
                  );
                  LocalCacheHelper.SetLocalStorageItemCbpxUserIVStringDynamic(
                      this.state.tmpEncryptIV,
                      storageType
                  );
                  LocalCacheHelper.SetLocalStorageItemM365UserObjectIdDynamic(
                      this.props.M365UserObjectId,
                      storageType
                  );
                  console.log("set data to localstorage > and refresh window");

                  // get information if user is cpbx 1 or cpbx 2 user
                  this.getKindOfCpbxUserBeforeShowingNextView();
              } else {
                  console.log(
                      "data is undefined or this.state.formErrorOccured is true > do nothing"
                  );
              }
          })
          .catch((error) => {
              this.setState({
                  formErrorOccured: true,
                  formErrorMsg: "Es ist ein unerwarteter Fehler aufgetreten."
              });
              console.log("error", error);
          });
  };

  // step 1 get encrypted value (which will be stored locally instead of pure base64-encoded crendentials)
  handleDoLogin = (): void => {
      console.log("start handleDoLogin");
      // xsi accepts just locercase usernames (which influences base64-encoded value) > so do lowercase now
      const unValue =
      (
        document.getElementById("tfInpUn") as HTMLInputElement
      ).value.toLowerCase() + this.cbpxInputsUNSuffix;
      const pwdValue = (document.getElementById("tfInpPwd") as HTMLInputElement)
          .value;
      const basicAuthStr = window.btoa(unValue + ":" + pwdValue);
      //   console.log(
      //       "unValue='" +
      //     unValue +
      //     "' | pwdValue='" +
      //     pwdValue +
      //     "' | basicAuthStr='" +
      //     basicAuthStr +
      //     "'"
      //   );

      const cpbxHeaders = CpbxApiHelper.GetCpbxRequestHeadersWithoutAuth();
      cpbxHeaders.append("Authorization", "Basic " + basicAuthStr);
      cpbxHeaders.append(
          ConstantsHttpHeader.XTeamsAppUserId,
          this.props.M365UserObjectId
      );

      const apiUrlFull = CpbxApiHelper.GetProxyUrlForEncryptAuthorizationHeader();
      //   console.log("apiUrlFull='" + apiUrlFull + "'");

      this.setState({
          un: unValue,
          isDoingLogin: true,
          formErrorOccured: false,
          formErrorMsg: "",
          loginTryNo: this.state.loginTryNo + 1,
          loginLastTryDateTimeInMs: Date.now(),
          loginForbidden: false
      });

      fetch(apiUrlFull, {
          method: "GET",
          headers: cpbxHeaders,
          redirect: "follow"
      })
          .then((response) => {
              console.log("response.ok='" + response.ok + "'");
              console.log("response.status='" + response.status + "'");
              console.log("response.statusText='" + response.statusText + "'");
              console.log("response.redirected='" + response.redirected + "'");
              if (response.ok) {
                  return response.json();
              } else if (response.status === 403) {
                  this.setState({
                      formErrorOccured: true,
                      formErrorMsg:
              "Verschlüsselung konnte nicht durchgeführt werden. Das sollte nicht passieren."
                  });
                  this.handleDoLoginWithDelay();
              } else {
                  throw new Error("Response not ok");
              }
          })
          .then((data) => {
              console.log(data);
              console.log(
                  "this.state.formErrorOccured='" + this.state.formErrorOccured + "'"
              );
              if (data !== undefined && this.state.formErrorOccured === false) {
                  this.setState({
                      tmpEncryptBasicAuthStr: data.encryptedAuthHeaderValue,
                      tmpEncryptIV: data.ivAsString
                  });
                  console.log("ok > call real cpbx-requst now");

                  this.handleDoLoginWithEncryptedData();
              }
          })
          .catch((error) => {
              this.setState({
                  formErrorOccured: true,
                  formErrorMsg: "Es ist ein unerwarteter Fehler aufgetreten."
              });
              console.log("error", error);
          });
  };

  onChangeTextFieldUserName = (): void => {
      this.resetFormErrorMsg();

      const unValue: string =
      (document.getElementById("tfInpUn") as HTMLInputElement).value +
      this.cbpxInputsUNSuffix;

      this.setState({
          unInputValue: unValue
      });

      // min-length: 5
      // a@b.de
      // if (unValue.length < this.cpbxInputsUNMinLength) {
      if (unValue.length <= this.cbpxInputsUNSuffix.length) {
          this.setState({
              unErrMsg:
          "Benutzername muss mindestens ein Zeichen vor dem @-Zeichen enthalten.",
              unValueIsValid: false
          });
          return;
      }

      // max-length: 80 (given by xsi-interface)
      if (unValue.length > this.cpbxInputsUNMaxLength) {
          this.setState({
              unErrMsg: "Benutzername ist zu lang.",
              unValueIsValid: false
          });
          return;
      }

      // do not allow spaces
      if (unValue.length !== unValue.replace(" ", "").length) {
          this.setState({
              unErrMsg: "Benutzername darf keine Leerzeichen enthalten.",
              unValueIsValid: false
          });
          return;
      }

      // only one @-character please
      // it seems to be faster to do string-functionality than to check it within regular-expression (which is slower
      // and currently i do not know how to check this... makes regexp much more complicated)
      if (unValue.split("@").length !== 2) {
          this.setState({
              unErrMsg:
          "Bitte nur den Benutzernamen eingeben. Die Ergänzung von @deutschland-lan.de erfolgt automatisch.",
              unValueIsValid: false
          });
          return;
      }

      // disable this check for now
      // checking for regular expression (needs to look like a email-address)
      // test regexp online here: https://regex101.com/
      // const emailRegExp : RegExp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      // old-school (american-style) email-regexp do not consider new-school (punycode) domains and top-level-domains
      // - punycode domains could contain äüöß (also russion characters a.s.o.)
      // - top-level-domains could be longer than 4 characters (e.g. .bayern or .shopping)
      // const emailRegExp: RegExp = /^.{1,50}@.+\..{2,14}$/si;
      // - this one allows empty character, newline etc.
      /*
        const emailRegExp: RegExp = /^.\S{0,51}@.\S{0,51}\..\S{0,14}$/si;
        // - this one allows empty character at the start > should be hardened later...
        if (emailRegExp.test(unValue.toLowerCase()) === false) {
            this.setState({
                unErrMsg: "Benutzername muss im erwarteten Email-Format angegeben werden! <name>@<domain>.<tld>",
                unValueIsValid: false
            });
            return;
        }
        */

      this.setState({
          unErrMsg: "",
          unValueIsValid: true
      });

  };

  onChangeTextFieldPwd = (): void => {
      this.resetFormErrorMsg();
      const pwdValue = (document.getElementById("tfInpPwd") as HTMLInputElement)
          .value;
      this.setState({
          pwdInputValue: pwdValue
      });

      // min-length: 3
      if (pwdValue.length < this.cpbxInputsPWDMinLength) {
          this.setState({
              pwdErrMsg:
          "Passwort muss mindestens " +
          this.cpbxInputsPWDMinLength +
          " Zeichen lang sein.",
              pwdValueIsValid: false
          });
          return;
      }
      // max-length: 30
      if (pwdValue.length > this.cpbxInputsPWDMaxLength) {
          this.setState({
              pwdErrMsg:
          "Passwort darf maximal " +
          this.cpbxInputsPWDMaxLength +
          " Zeichen lang sein. (Aktuelle Länge: " +
          pwdValue.length +
          " Zeichen)",
              pwdValueIsValid: false
          });
          return;
      }
      this.setState({
          pwdErrMsg: "",
          pwdValueIsValid: true
      });
  };

  onChangeSaveLoginForever = (ev, checked: boolean): void => {
      console.log("onChangeSaveLoginForever [checked='" + checked + "']");
      // value will be used while clicking login-button
      this.setState({
          saveLoginForever: checked
      });
  };

  resetFormErrorMsg = (): void => {
      this.setState({
          formErrorOccured: false,
          formErrorMsg: ""
      });
  };

  render() {
      const displayErrorMsg: boolean = this.state.formErrorOccured;
      const errorMsgCssClass: string =
      displayErrorMsg === true
          ? "cpbxInputsPWErrorShow"
          : "cpbxInputsPWErrorHide";
      initializeIcons(/* optional base url */);
      let waitingAnimation;
      if (this.state.isDoingLogin) {
          waitingAnimation = (
              <div className="waitingAnimationLoginView">
                  <Loader size="larger">Loading</Loader>
              </div>
          );
      }
      return (
          <div className="cpbxContOuter ms-Grid">
              <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl6 ms-xlPush8 ms-xxlPush6 cpbxContInner cpbxContInnerLogo">
                      <div className="cpbxBgLogoCont">
                          <Image
                              className="cpbxBgLogo"
                              {...this.imageProps}
                              alt="TelekomLogo"
                          />
                      </div>
                      <div className="cpbxBgLogoCont">
                          <Image
                              className="cpbxBgLogoMobile"
                              {...this.imagePropsMobile}
                              alt="TelekomLogo"
                          />
                      </div>
                  </div>
                  <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl8 ms-xxl6 ms-xlPull4 ms-xxlPull6 cpbxContInner">
                      <div className="cpbxLogingsiteHeader">
                          <h1>Herzlich willkommen in der Telekom Cloud PBX App</h1>
                      </div>
                      <div className="cpbxLogingsiteTitle">
                          <h2>Bitte melden Sie sich an</h2>
                      </div>
                      <div className="cpbxText">
                          <p>
                Melden Sie sich zunächst mit Ihren Anmeldedaten an, um die
                Telefonie-Funktionen Ihrer Telefonanlage mit CompanyFlex Cloud
                PBX direkt in Microsoft Teams zu nutzen. Stellen Sie
                beispielsweise laufende Gespräche von Ihrem Telefon direkt auf
                den Desktop-Client durch, nutzen Sie die Wahlwiederholung oder
                übernehmen Sie Anrufe Ihrer Kolleg*innen.
                          </p>
                      </div>
                      <div className="cpbxInputsCont">
                          <Stack
                              {...this.columnProps}
                              className="cpbxInputsUNInputStackSuffix"
                          >
                              <div className="cpbxInputsUN">
                                  <TextField
                                      id="tfInpUn"
                                      className="cpbxInputsUNInput"
                                      suffix={this.cbpxInputsUNSuffix}
                                      type="text"
                                      required
                                      maxLength={this.cpbxInputsUNMaxLength}
                                      disabled={this.state.isDoingLogin}
                                      onChange={this.onChangeTextFieldUserName}
                                  />
                                  <span
                                      className={
                                          "cpbxInputsUNLabel " +
                      (this.state.unInputValue.length > 0
                          ? "isFilled"
                          : "isNotFilled")
                                      }
                                  >
                    Benutzername
                                  </span>
                              </div>
                          </Stack>
                          <div className="cpbxInputsUNPlaceholdeAndInfo">
                              <div
                                  className={
                                      "cpbxInputsUNPlaceholder " +
                    (this.state.unInputValue.length === 0
                        ? "isVisible"
                        : "isNotVisible")
                                  }
                              >
                                  <span>
                    max.muster (@deutschland-lan.de wird automatisch
                    hinzugefügt)
                                  </span>
                              </div>
                              <div className="cpbxInputsUNLengthInfo">
                                  <span>
                                      {this.state.unInputValue.length +
                      "/" +
                      this.cpbxInputsUNMaxLength}
                                  </span>
                              </div>
                          </div>
                          <div className="cpbxInputsErrorMessage">
                              <span>{this.state.unErrMsg}</span>
                          </div>
                          <div className="cpbxInputsPW">
                              <TextField
                                  id="tfInpPwd"
                                  className="cpbxInputsPWInput"
                                  type="password"
                                  required
                                  maxLength={this.cpbxInputsPWDMaxLength}
                                  disabled={
                                      this.state.isDoingLogin || this.state.loginForbidden
                                  }
                                  onChange={this.onChangeTextFieldPwd}
                              />
                              <span
                                  className={
                                      "cpbxInputsPWLabel " +
                    (this.state.pwdInputValue.length > 0
                        ? "isFilled"
                        : "isNotFilled")
                                  }
                              >
                  Passwort
                              </span>
                          </div>
                          <div className="cpbxInputsErrorMessage">
                              <span>{this.state.pwdErrMsg}</span>
                          </div>
                          <div className={errorMsgCssClass}>
                              <p>{this.state.formErrorMsg}</p>
                              <p>
                  Falls Sie sich das erste Mal anmelden möchten oder Ihr
                  Passwort vergessen haben, klicken Sie hier zur{" "}
                                  <a
                                      className="cpbxInputsPWErrorShowLink"
                                      href={ConstantsUrls.ResetPasswortUrl}
                                      target="_blank"
                                      rel="noreferrer"
                                  >
                    Erstanmeldung oder zum Zurücksetzen des Passwortes
                                  </a>
                              </p>
                              {/* <p>{this.state.formErrorMsg}</p> */}
                          </div>
                          <div className="cpbxLoginCont">
                              <div className="cpbxLoginCheckboxCont">
                                  <Checkbox
                                      className="cpbxLoginCheckbox"
                                      checked={this.state.saveLoginForever}
                                      onChange={this.onChangeSaveLoginForever}
                                  />
                                  <span className="checkmark"></span>
                                  <span className="cpbxLoginCheckboxLabel">
                    Angemeldet bleiben
                                  </span>
                              </div>
                              <div className="cpbxLoginBNPWLink">
                                  <a
                                      href={ConstantsUrls.ResetPasswortUrl}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="cpbxLoginBNPWLinkText"
                                  >
                    Benutzername oder Passwort vergessen?
                                  </a>
                              </div>
                              <PrimaryButton
                                  className="cpbxLoginButton"
                                  text="Login"
                                  onClick={this.handleDoLogin || this.state.loginForbidden}
                                  allowDisabledFocus
                                  disabled={
                                      this.state.unValueIsValid === false ||
                    this.state.pwdValueIsValid === false ||
                    this.state.isDoingLogin === true ||
                    this.state.loginForbidden === true
                                  }
                              />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner cpbxFooter">
                      <div>
                          <AppVersionInfo />
                      </div>
                      <div className="cpbxFeedbackLink">
                          <AppFeedback />
                      </div>
                  </div>
              </div>
              <WelcomeDialog />
              <DecommissionDialog/>
              {waitingAnimation}
          </div>
      );
  }
}

export default CpbxLogin;
